export default class APIAffiliate {
  constructor(API) {
    this.api = API;
  }
  async getAffiliatePaymentsFromToTimestamp(from, to) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/tenant/report/affiliate';
    req.appendQueryParam('from', from);
    req.appendQueryParam('to', to);
    return await req.exec();
  }
}
